import { ErrorQuestionReportPage } from "./ErrorQuestionReportPage";
export default ErrorQuestionReportPage;
